import { z } from "zod";

import { ALL_ICON_KEYS } from "lib/icons/untitled_ui/UIcon";

// Schema for the `announcement-card` DevCycle JSON flag. Discriminated union so
// new announcement types can be added without breaking existing ones.

const announcementBaseShape = z.object({
  enabled: z.boolean().default(false),
  id: z.string().min(4).max(64),
  title: z.string(),
  subline: z.string().optional(),
  imageUrl: z.url({ protocol: /^https$/, hostname: /\.stotles\.com$/ }).optional(),
  action: z
    .object({
      url: z.url({ protocol: /^https$/ }),
      text: z.string().optional().default("Learn More"),
      icon: z.enum(ALL_ICON_KEYS).optional().default("linkExternal02"),
    })
    .optional(),
});

const announcementBasic = announcementBaseShape.extend({
  type: z.literal("basic"),
});

const announcementWebinar = announcementBaseShape.extend({
  type: z.literal("webinar"),
  webinarDate: z.iso.datetime(),
});

export const announcementSchema = z.discriminatedUnion("type", [
  announcementBasic,
  announcementWebinar,
]);

export type Announcement = z.infer<typeof announcementSchema>;
export type BasicAnnouncement = z.infer<typeof announcementBasic>;
export type WebinarAnnouncement = z.infer<typeof announcementWebinar>;
